import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../../common/components/base.component';
import { ButtonTriggerEvent } from '../../../../../common/components';
import { SpiderPage } from '../event.spider.modal.component';

@Component({
  templateUrl: './set.eventpage.tag.modal.component.html',
  styleUrls: ['./set.eventpage.tag.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SetEventPageTagModalComponent extends BaseComponent {
  form: FormGroup;
  url: string;
  tag: string;
  page: SpiderPage;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<SetEventPageTagModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: SpiderPage
  ) {
    super();
    if (data) {
      this.page = Object.assign({}, data);
    } else {
      this.page = new SpiderPage('eventbrite', '');
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      url: [this.page.url, []],
      tag: [this.page.tag, []],
    });
  }

  save() {
    this.dialogRef.close({
      _id: this.page._id,
      url: this.form.value.url,
      tag: this.form.value.tag,
      socialName: this.page.socialName,
    });
  }

  close() {
    this.dialogRef.close();
  }
}

// export class SetEventPageTagModalActions {
//   confirm: (event: ButtonTriggerEvent) => void;
//   cancel?: () => void;
// }

// export class SetEventPageTagModalData {
//   page: any;
//   constructor(page?) {
//     this.page = page;
//   }
// }



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/event.spider/set.eventpage.tag.modal/set.eventpage.tag.modal.component.ts